window.SiteReady(($) => {

  console.log('Init Block: Header - Carousel');

  $('.js-header_carousel').each((index, el) => {
    let $carousel = $(el);
    let $splide = $carousel.find('.js-splide');

    $carousel.find('.js-header_carousel_item').eq(0).find('.js-swap').swap('activate');

    if ($splide.length) {
      let data = $splide.data('splide-data');

      data.Splide.on('move', (newIndex, oldIndex, destIndex) => {
        data.$items.eq(oldIndex).find('.js-swap').swap('deactivate');
        data.$items.eq(newIndex).find('.js-swap').swap('activate');
      });
    }
  });

});